import { useState } from "react";
import "./PreKoho.scss";

/**
 * Kto so systemom pracuje -- prepinac roli namiesto styroch kariet s ikonkou.
 * Kazda rola ma vetu v prvej osobe a to, co v systeme naozaj robi
 * (zodpoveda roliam ADMIN / MANAGER / DRIVER / CUSTOMER v backend/docs/rozvozy.md).
 */
const ROLY = [
  {
    key: "majitel",
    nazov: "Majiteľ",
    veta: "Viem, koľko sme dnes predali a kto nám dlží — aj keď nie som v prevádzke.",
    body: [
      "Tržby, dlhy a predajnosť jedál na jednom dashboarde",
      "Firemné cenníky, trasy a časy rozvozov",
      "Účty pre vedúcich a vodičov, každý vidí len to svoje",
    ],
  },
  {
    key: "veduci",
    nazov: "Vedúci / dispečer",
    veta: "Objednávku zapíšem skôr, ako zákazník dopovie, čo chce.",
    body: [
      "Zákazník podľa kódu, aj s viacerými adresami",
      "Týždenné menu a denné limity jedál",
      "Prehľad objednávok podľa trás a stavu, export do Excelu",
    ],
  },
  {
    key: "vodic",
    nazov: "Vodič",
    veta: "V mobile mám všetky svoje zastávky a pri každej vidím, či zákazník niečo dlží.",
    body: [
      "Adresa, telefón a poznámka k zastávke na jedno ťuknutie",
      "Zápis platby: hotovosť, karta, faktúra alebo dlh",
      "Koľko jedál ešte vezie a koľko už vybral",
    ],
  },
  {
    key: "zakaznik",
    nazov: "Zákazník",
    veta: "Menu si pozriem na webe a zavolám, až keď viem, čo chcem.",
    body: [
      "Denné menu na adrese vašej prevádzky",
      "Objednávka cez web, ak ju prevádzka zapne",
      "Kontakt a časy rozvozov na jednom mieste",
    ],
  },
];

function PreKoho() {
  const [aktivna, setAktivna] = useState(ROLY[0].key);

  return (
    <section className="prekoho" id="pre-koho">
      <h2 className="prekoho__title">Kto s tým bude robiť?</h2>

      <div className="prekoho__tabs" role="tablist" aria-label="Roly">
        {ROLY.map((r) => (
          <button
            key={r.key}
            type="button"
            role="tab"
            id={`prekoho-tab-${r.key}`}
            aria-selected={aktivna === r.key}
            aria-controls={`prekoho-panel-${r.key}`}
            className={`prekoho__tab${aktivna === r.key ? " prekoho__tab--active" : ""}`}
            onClick={() => setAktivna(r.key)}
          >
            {r.nazov}
          </button>
        ))}
      </div>

      {/* Vsetky roly su v DOM-e, neaktivne len `hidden` -- AI crawlery a
          vyhladavace citaju aj skryty text, ale nie text, ktory v DOM-e nie je.
          Prechod z display:none znova spusti animaciu prekoho-in. */}
      {ROLY.map((rola) => (
        <div
          key={rola.key}
          className="prekoho__panel"
          role="tabpanel"
          id={`prekoho-panel-${rola.key}`}
          aria-labelledby={`prekoho-tab-${rola.key}`}
          hidden={aktivna !== rola.key}
        >
          <blockquote className="prekoho__quote">„{rola.veta}“</blockquote>
          <ul className="prekoho__list">
            {rola.body.map((b) => (
              <li key={b}>{b}</li>
            ))}
          </ul>
        </div>
      ))}
    </section>
  );
}

export default PreKoho;
